<template>
    <div class="about-layout__credit_form">
        <form class="form-default">
            <div class="fields">
                <no-ui-slider v-model="payment.value" ref="payment"
                              title="Ежемесячный платёж"  
                              :min="payment.min" :max="payment.max" :step="payment.step" :start="payment.start" 
                              postfix="руб" :view="payment.value | threeDigits"></no-ui-slider>
                <no-ui-slider v-model="deposit.value" ref="deposit"
                              title="Первоначальный взнос" :min="deposit.min" :max="deposit.max" :step="deposit.step" :start="deposit.start" 
                              postfix="руб" :view="deposit.value | threeDigits"></no-ui-slider>
                <label class="input-container">
                    <input type="checkbox" v-model="isFamily">
                    <span class="input-container__label">
                        <span>Семейная ипотека с государственной поддержкой</span> 
                        <slot name="family-link"></slot>                      
                    </span>
                </label>    
            </div>
            <div class="bottom">
                <p>Вы можете рассчитывать&nbsp;на:</p>
                <div class="result">
                    <small>Общая сумма</small>
                    <span>{{result | threeDigits }} <i class="ruble"></i></span>
                </div>
                <slot name="button">
                    <button @click.prevent="toCatalog()" class="button-pill filled" type="submit">Подобрать квартиру</button>
                </slot>        
            </div>
        </form>
    </div>
</template>

<script>
    import noUiSlider from './NoUiSlider.vue';
    import threeDigits from '../filters/threeDigits';
    import { PV } from './CreditLogic';
 
    export default {
        props:['years', 'rate', 'familyRate'],
        data() {
            return {
                // емежесячный платеж
                payment: {
                    min: 10000,
                    max: 200000,
                    step: 1000,
                    start: 30000,
                    value: 30000
                }, 

                // первоначальный взнос
                deposit: {
                    min: 100000,
                    max: 10000000,
                    step: 10000,
                    start: 560000,
                    value: 560000
                }, 

                // Семейная ипотека
                isFamily: false 
            }
        },
        computed: {
            result: function () {
                let rate = this.isFamily ? (this.familyRate / 100 / 12) : (this.rate / 100 / 12);
                let months = this.years * 12;
                return parseFloat(this.PV(rate, months, this.payment.value)) + parseFloat(this.deposit.value);
            },
            minDeposit: function () {
                return this.result / 100 * 15;
            },
            avalDeposit() {
                return this.minDeposit - (this.minDeposit % this.deposit.step) + this.deposit.step;
            }
        },
        watch: {
            result() {
                if (this.deposit.value < this.avalDeposit) {
                    this.$refs.deposit.$el.querySelector('.numslider__slider').noUiSlider.set(this.avalDeposit);
                }              
            }        
        },
        methods: {
            PV,
            toCatalog() {
                window.location.href = "/catalog/" + `?price[maximum]=${Math.trunc(this.result)}`;                
            }
        },
        components: {
            noUiSlider
        },
        filters: {
            threeDigits
        }
    }
</script>